import axiosInstance from './axiosInstance';
import API_CONFIG from '../config/api';

const learningService = {
    // Get all suggestions
    getSuggestions: async () => {
        const response = await axiosInstance.get(API_CONFIG.ENDPOINTS.CLIENT_SUGGESTIONS);
        return response.data;
    },

    // Approve a suggestion
    approveSuggestion: async (id) => {
        const response = await axiosInstance.post(`${API_CONFIG.ENDPOINTS.CLIENT_SUGGESTIONS}${id}/approve/`);
        return response.data;
    },

    // Reject a suggestion
    rejectSuggestion: async (id) => {
        const response = await axiosInstance.post(`${API_CONFIG.ENDPOINTS.CLIENT_SUGGESTIONS}${id}/reject/`);
        return response.data;
    }
};

export default learningService;
